export const CORNER_ORDER = ["lf", "rf", "lr", "rr"] as const;
export type Corner = (typeof CORNER_ORDER)[number];

export const PREDICTED_COLORS: Record<Corner, string> = {
  lf: "rgb(126, 212, 126)",
  rf: "rgb(228, 196, 122)",
  lr: "rgb(158, 203, 255)",
  rr: "rgb(224, 142, 184)",
};

export const RECORDED_COLORS: Record<Corner, string> = {
  lf: "rgba(126, 212, 126, 0.28)",
  rf: "rgba(228, 196, 122, 0.28)",
  lr: "rgba(158, 203, 255, 0.28)",
  rr: "rgba(224, 142, 184, 0.28)",
};

export const SERIES_INDEX = {
  recorded:  (c: Corner): number => 1 + CORNER_ORDER.indexOf(c),
  predicted: (c: Corner): number => 5 + CORNER_ORDER.indexOf(c),
};
